import React from 'react';
import LegalLayout, { LegalSection } from 'components/ui/LegalLayout';
import withPageOverride from './withPageOverride';

const PrivacyPolicyDefault = () => (
    <LegalLayout title="Политика конфиденциальности" lastUpdated="19 мая 2026 г.">
        <p>
            Настоящая Политика конфиденциальности (далее — «Политика») разъясняет, какие
            персональные данные собирает сервис <strong>SecureAuth Enterprise</strong>
            (далее — «Сервис»), для каких целей они обрабатываются, как защищаются и какие
            права имеют пользователи.
        </p>
        <p>
            Используя Сервис, вы подтверждаете согласие с условиями настоящей Политики.
            Если вы не согласны с какими-либо условиями, прекратите использование Сервиса.
        </p>

        <LegalSection title="1. Сведения об операторе">
            <p>
                Оператором персональных данных является администрация Сервиса
                <strong> SecureAuth Enterprise</strong>. Контакты ответственного за обработку
                персональных данных лица указаны на странице{' '}
                <a href="/support" className="text-primary underline">Поддержка</a>.
            </p>
        </LegalSection>

        <LegalSection title="2. Категории обрабатываемых данных">
            <ul className="list-disc pl-6 space-y-1">
                <li>учётные данные (email, имя пользователя, имя и фамилия);</li>
                <li>пароль (хранится в виде криптографического хэша);</li>
                <li>метаданные сессий (IP-адрес, User-Agent, время входа);</li>
                <li>идентификаторы устройств и активных сессий;</li>
                <li>пользовательские настройки интерфейса.</li>
            </ul>
        </LegalSection>

        <LegalSection title="3. Цели обработки">
            <ul className="list-disc pl-6 space-y-1">
                <li>регистрация и аутентификация пользователя;</li>
                <li>предоставление доступа к функциям Сервиса в соответствии с ролью;</li>
                <li>обеспечение безопасности (предотвращение несанкционированного доступа);</li>
                <li>исполнение требований законодательства;</li>
                <li>информирование о критически важных событиях аккаунта.</li>
            </ul>
        </LegalSection>

        <LegalSection title="4. Правовые основания">
            <p>
                Обработка осуществляется на основании согласия пользователя, выраженного при
                регистрации, а также в соответствии с применимым законодательством
                (152-ФЗ «О персональных данных», GDPR — для пользователей из ЕС).
            </p>
        </LegalSection>

        <LegalSection title="5. Cookies и аналогичные технологии">
            <p>
                Сервис использует cookies и аналогичные технологии исключительно для
                функциональных целей: хранения сессии, защиты от CSRF и сохранения
                настроек интерфейса. Аналитические и рекламные cookies не используются.
            </p>
        </LegalSection>

        <LegalSection title="6. Передача данных третьим лицам">
            <p>
                Сервис не передаёт персональные данные третьим лицам, за исключением
                случаев, предусмотренных законодательством, а также при использовании
                инфраструктуры провайдеров, обеспечивающих хостинг и доставку трафика.
            </p>
        </LegalSection>

        <LegalSection title="7. Срок хранения">
            <p>
                Данные хранятся в течение всего срока использования аккаунта и в течение
                <strong> 90 дней</strong> после его удаления — для возможности восстановления
                и выполнения требований законодательства.
            </p>
        </LegalSection>

        <LegalSection title="8. Меры защиты">
            <ul className="list-disc pl-6 space-y-1">
                <li>шифрование канала связи (TLS 1.2+);</li>
                <li>хэширование паролей (Argon2 / bcrypt);</li>
                <li>защита от CSRF, XSS, brute-force атак;</li>
                <li>ротация refresh-токенов и httpOnly cookies;</li>
                <li>журналирование действий и мониторинг аномалий.</li>
            </ul>
        </LegalSection>

        <LegalSection title="9. Права пользователя">
            <ul className="list-disc pl-6 space-y-1">
                <li>получать сведения о своих данных и целях их обработки;</li>
                <li>требовать уточнения, блокирования или удаления данных;</li>
                <li>отозвать согласие на обработку;</li>
                <li>обжаловать действия Сервиса в надзорный орган.</li>
            </ul>
            <p>
                Для реализации перечисленных прав направьте запрос через раздел{' '}
                <a href="/support" className="text-primary underline">Поддержка</a>.
            </p>
        </LegalSection>

        <LegalSection title="10. Изменения Политики">
            <p>
                Сервис вправе изменять настоящую Политику. Существенные изменения
                публикуются на этой странице и (при необходимости) сообщаются
                пользователю по email.
            </p>
        </LegalSection>
    </LegalLayout>
);

export default withPageOverride('privacy', PrivacyPolicyDefault);
